import React from "react";
import { Box, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { ImageMetadata } from "../types";
import { FrameMetricTooltip } from "./FrameMetricTooltip";

interface StarEccentricityChartProps {
  imagesForView: ImageMetadata[];
}

const StarEccentricityChart: React.FC<StarEccentricityChartProps> = ({
  imagesForView,
}) => {
  // Only use light frames for statistics
  const lightFrames = imagesForView.filter((img) => img.FrameType === "LIGHT");
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderRadius: 3,
        p: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
        minHeight: 400,
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
      >
        Star Eccentricity
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Star shape measurements (lower is better, 0 = perfect circle)
      </Typography>
      {lightFrames.length === 0 ? (
        <Typography color="text.secondary">No data available.</Typography>
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <LineChart
            data={lightFrames
              .map((img, i) => ({ frame: i + 1, ecc: img.Eccentricity }))
              .filter((d) => typeof d.ecc === "number" && isFinite(d.ecc))}
          >
            <XAxis
              dataKey="frame"
              stroke="#a0a0a0"
              tick={{ fill: "#a0a0a0" }}
              tickLine={false}
              axisLine={{ stroke: "#333" }}
            />
            <YAxis
              stroke="#a0a0a0"
              tick={{ fill: "#a0a0a0" }}
              tickLine={false}
              axisLine={{ stroke: "#333" }}
              domain={[0, "auto"]}
            />
            <Tooltip
              content={<FrameMetricTooltip labelName="Eccentricity" />}
            />
            <Line
              type="monotone"
              dataKey="ecc"
              stroke="#ff8a65"
              strokeWidth={2}
              dot={{ r: 2, fill: "#ff8a65" }}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </Box>
  );
};

export default StarEccentricityChart;
